import React from "react";
import { Card, Tag, Typography, Row, Col, Space, Button } from "antd";
import {
  EnvironmentOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import "./RehabCenterCard.css";

const { Title, Text, Link } = Typography;

const RehabCenterCard = ({ rehabCenter, onBookAppointment }) => {
  const {
    name,
    address_line1,
    locality,
    city_town,
    district,
    state,
    pincode,
    phone_country_code,
    phone_number,
    whatsapp_country_code,
    whatsapp_number,
    google_maps_link,
    services,
    open_from,
    open_to,
    is_open_24_hours,
  } = rehabCenter;

  const fullAddress = `${address_line1}${locality ? `, ${locality}` : ""}${
    city_town ? `, ${city_town}` : ""
  }${district ? `, ${district}` : ""}, ${state} - ${pincode}`;

  const formatPhoneNumber = (code, number) => {
    if (!number) return "N/A";
    return `${code} ${number}`;
  };

  const getWhatsAppLink = (code, number) => {
    if (!number) return null;
    const fullNumber = `${code}${number}`;
    return `https://wa.me/${fullNumber.replace(/\D/g, "")}`;
  };

  const renderTags = (items, color) => {
    if (!items) return <Text type="secondary">N/A</Text>;
    return items.split(",").map((item) => (
      <Tag color={color} key={item.trim()} style={{ margin: "2px" }}>
        {item.trim()}
      </Tag>
    ));
  };

  const formatTo12Hour = (timeStr) => {
    if (!timeStr) return "N/A";
    const [hour, minute] = timeStr.split(":");
    const date = new Date();
    date.setHours(+hour);
    date.setMinutes(+minute);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const timings = is_open_24_hours
    ? "Open 24 hours"
    : open_from && open_to
    ? `${formatTo12Hour(open_from)} - ${formatTo12Hour(open_to)}`
    : "Timings not available";

  const timingTagColor = is_open_24_hours ? "green" : "default";

  return (
    <Card hoverable className="rehab-center-details-card compact">
      <div className="card-header">
        <Link
          href={
            google_maps_link ||
            `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              name + " " + fullAddress
            )}`
          }
          target="_blank"
          rel="noopener noreferrer"
          className="rehab-center-name-link"
        >
          {name} <EnvironmentOutlined />
        </Link>
        <Tag color={timingTagColor} className="rehab-center-timings-tag">
          <ClockCircleOutlined style={{ marginRight: 5 }} />
          {timings}
        </Tag>
      </div>
      <div className="card-section address-section">
        <Text>{fullAddress}</Text>
      </div>
      <Row gutter={[16, 8]} className="card-section contact-section">
        <Col xs={24} sm={whatsapp_number ? 12 : 24}>
          <Space direction="vertical" size="small">
            <Text strong>
              <PhoneOutlined /> Phone:
            </Text>
            <Link href={`tel:${phone_country_code}${phone_number}`}>
              {formatPhoneNumber(phone_country_code, phone_number)}
            </Link>
          </Space>
        </Col>
        {whatsapp_number && (
          <Col xs={24} sm={12}>
            <Space direction="vertical" size="small">
              <Text strong>
                <WhatsAppOutlined /> WhatsApp:
              </Text>
              <Link
                href={getWhatsAppLink(whatsapp_country_code, whatsapp_number)}
                target="_blank"
                rel="noopener noreferrer"
              >
                Chat on WhatsApp
              </Link>
            </Space>
          </Col>
        )}
      </Row>
      <div className="card-section">
        <Text strong>
          <CheckCircleOutlined /> Services Offered:
        </Text>
        <div style={{ marginTop: '8px' }}>{renderTags(services, "green")}</div>
      </div>
      <div className="card-section booking-section">
        <Button
          type="primary"
          icon={<CalendarOutlined />}
          onClick={() => onBookAppointment(rehabCenter)}
          block
          style={{ marginTop: "10px" }}
        >
          Book Appointment
        </Button>
      </div>
    </Card>
  );
};

export default RehabCenterCard;